import ActionTypes from 'core/actions/actionTypes';
import initialState from 'core/reducers/initialState';
import { ExternalCallbackRegistry } from 'core/util/IExternalCallback';
import ConfigUtil from "../../util/config/ConfigUtil";

/**
 * @overview:
 *
 * @author: jesposito
 */

declare var window: any;

// get the config
const requiredActions = ConfigUtil.get("startup") as string[];

export default function initializationReducer(state = initialState.initialization, action: any) {

	// we see if each of the requires actions is dispatched the required number of times
	// if so then the startup sequence is complete and the root {@link App} compoent can render

	if(!state.done && requiredActions.includes(action.type)) {

		const count = state.count + 1;
		let done = state.done;

		if(count >= requiredActions.length) {

			window.DI = { active: true };

			done = true;
		}

		return {...state, count, done};

	}

	return state;
}



// WEBPACK FOOTER //
// ./src/core/reducers/initialization/initializationReducer.ts